'use client';

import { FC, useEffect, useState } from 'react';
import BlogHero from '@/components/BlogPage/BlogHero';
import LatestPost from '@/components/BlogPage/LatestPost';
import PostsList from '@/components/BlogPage/PostsList';
import { BlogPageDto, BlogPostDto, BlogTagDto } from '@/components/BlogPage/types';
import useDevice from '@/hooks/useDevice';
import { getBlogPostsAfterSsrBatch } from '@/lib/blog';
interface Props {
  blogPageData: BlogPageDto;
  postsData: BlogPostDto[];
  tagsData: BlogTagDto[];
}
const BlogPage: FC<Props> = ({
  blogPageData,
  postsData,
  tagsData
}) => {
  const device = useDevice();
  const isMobile = device === 'mobile';
  const [allPosts, setAllPosts] = useState<BlogPostDto[]>(postsData ?? []);
  useEffect(() => {
    let cancelled = false;
    const fetchRestPosts = async () => {
      try {
        const rest = await getBlogPostsAfterSsrBatch();
        if (cancelled || !rest.length) return;
        setAllPosts(prev => [...prev, ...rest]);
      } catch (error) {
        console.error('[BlogPage] getBlogPostsAfterSsrBatch failed', error);
      }
    };
    fetchRestPosts();
    return () => {
      cancelled = true;
    };
  }, []);
  const latestPost = allPosts[0];
  const posts = allPosts.length ? isMobile ? allPosts : allPosts.slice(1) : null;
  return <>
			{blogPageData ? <BlogHero data={blogPageData} /> : null}

			{latestPost && !isMobile ? <div className="container">
					<LatestPost post={latestPost} />
				</div> : null}

			{posts ? <PostsList posts={posts} tags={tagsData} initialVisiblePostsCount={blogPageData?.initialVisiblePostsCount} /> : null}
		</>;
};
export default BlogPage;